import { Component, input, inject, computed, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormMode } from 'app/core/constants/form-mode';
import { CatalogService } from '@services/data/catalog.service';
import { RuleService } from '../../../rule-management/services/rule.service';

@Component({
  selector: 'app-process-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './process-form.component.html'
})
export class ProcessFormComponent implements OnInit {
  processForm = input.required<FormGroup>();
  mode = input.required<FormMode>();
  formMode = FormMode;

  private catalogService = inject(CatalogService);
  private ruleService = inject(RuleService);

  rules = signal<any[]>([]);

  settlementTargets = [
    { value: 'NONE', label: 'Ninguno' },
    { value: 'ENTITY_PAYMENT', label: 'Pago entidad (entity_payment)' },
    { value: 'REIMBURSEMENT', label: 'Reembolso (reimbursement)' }
  ];

  categories = computed(() =>
    (this.catalogService.processCategories() || []).map((c: any) => ({
      value: c.slug,
      label: `${c.name} (${c.slug})`
    }))
  );

  ruleOptions = computed(() =>
    (this.rules() || []).map((r: any) => ({
      slug: r.slug || r.code,
      label: `${r.slug || r.code} — ${r.description || ''}`
    }))
  );

  ngOnInit(): void {
    this.ruleService.get().subscribe({
      next: (res: any) => this.rules.set(Array.isArray(res) ? res : (res?.data ?? [])),
      error: () => this.rules.set([])
    });
  }
}
